import { env } from "~/env";

export const ContactInfo = ({ className = "" }: { className?: string }) => (
  <p className={`pt-4 text-sm text-gray-600 md:text-base ${className}`}>
    Need help? Text{" "}
    <a
      href={`tel:${env.VITE_SUPPORT_PHONE_NUMBER_RAW}`}
      className="text-indigo underline"
    >
      {env.VITE_SUPPORT_PHONE_NUMBER}
    </a>
  </p>
);
